import { useCreateRecordV2, useFetchOneAppByTypeV2 } from "@lhd/hooks";
import { AppTypes, DISPLAY_SIZES } from "@lhd/types";
import { FormInstance } from "antd/es/form/Form";
import { useState } from "react";
import { RiArrowGoBackFill } from "react-icons/ri";
import { useParams, useSearchParams } from "react-router-dom";
import LayoutApp from "../../LayoutApp";

import Button from "@lhd/components/Button";
import ModalConfirm from "@lhd/components/Modal/ModalConfirm";
import {
  BUTTON_HEIGHT,
  FONT_SIZE,
  FONT_SIZE_VALUE,
  ROUTES,
} from "@lhd/constants";
import { COMPANY_DETAIL_TABS } from "@lhd/features/UserCompanies/CompanyDetail/utility";
import { getCompanyId } from "@lhd/utility";
import { Form } from "antd";
import { useNavigate } from "react-router-dom";
import { APP_TYPES, BACK_NAVIGATE_URL_KEY } from "../../constants";
import {
  UploadStatusProvider,
  useUploadStatus,
} from "../../contexts/UploadStatusContext";
import { handleDataSubmitFinish } from "../../untils";
import { useSelector } from "react-redux";
import { getDisplaySize } from "@lhd/components/DisplaySizeSelector/selector";

interface IProps {
  appType: AppTypes;
  getInstanceForm?: (form: FormInstance<any>) => void;
  url: string;
  disabledOnCreate?: boolean;
}
const CreatePageInner = (props: IProps) => {
  const { appId } = useParams();
  const navigate = useNavigate();
  const { appType, disabledOnCreate = false } = props;
  const uploadStatus = useUploadStatus();
  const [openConfirmBack, setOpenConfirmBack] = useState(false);
  const {
    data: dataApp,
    isLoading: isLoadingApp,
    isSuccess: isSuccessApp,
  } = useFetchOneAppByTypeV2(appType);
  const [form] = Form.useForm();
  const { companyId: companyIdParam } = useParams();
  const [searchParams] = useSearchParams();
  const backNavigateUrl = searchParams.get(BACK_NAVIGATE_URL_KEY);
  const companyId = companyIdParam || getCompanyId();
  const { mutateAsync: createRecordAsync, isLoading: isCreating } =
    useCreateRecordV2({ appType, appId: appId || "", companyId });

  const handleBack = () => {
    if (backNavigateUrl) {
      navigate(decodeURIComponent(backNavigateUrl));
      return;
    }
    if (appType === APP_TYPES.COMPANY_POLICIES) {
      navigate(`/${ROUTES.COMPANY_POLICIES}`);
    } else if (appType === APP_TYPES.FINANCIAL_REPORTS) {
      navigate(`/${ROUTES.FINANCIAL_REPORTS}`);
    } else if (appType === APP_TYPES.BUSINESS_TRIP_REPORTS) {
      navigate(`/${ROUTES.BUSINESS_TRIP_REPORTS}`);
    } else if (appType === APP_TYPES.EMPLOYMENT_CONTRACTS) {
      navigate(
        `/${ROUTES.COMPANIES}/${companyId}?tab=${COMPANY_DETAIL_TABS.EMPLOYMENT_CONTRACTS.key}`,
      );
    } else if (appType === APP_TYPES.BUSINESS_FLOW) {
      navigate(`/${ROUTES.BUSINESS_FLOW}`);
    } else if (appType === APP_TYPES.BUSINESS_MANUALS) {
      navigate(`/${ROUTES.BUSINESS_MANUALS}`);
    }
  };

  const handleBackClick = () => {
    if (form.isFieldsTouched()) {
      setOpenConfirmBack(true);
    } else {
      handleBack();
    }
  };

  const displaySize = useSelector(getDisplaySize) as
    | keyof typeof FONT_SIZE
    | keyof typeof BUTTON_HEIGHT;
  const size = FONT_SIZE_VALUE[displaySize ?? DISPLAY_SIZES.SMALL];

  const isChart = searchParams.has("isChart");

  const renderButtonActions = () => {
    return (
      <div className="d-flex gap-2 ml-3">
        <Button
          disabled={!!uploadStatus?.isUploading || isCreating}
          label={"保存"}
          onClick={form.submit}
          loading={isCreating}
          style={{
            fontSize: size,
            width: "fit-content",
          }}
          displaySize={displaySize}
        />
        {searchParams.get("from") !== ROUTES.BUSINESS_CONTROLS_CHART &&
          searchParams.get("from") !== ROUTES.COMPANY_POLICIES_CHART &&
          !isChart && (
            <Button
              icon={
                <div className="flex-center">
                  <RiArrowGoBackFill size={16} />
                </div>
              }
              className="btn-back"
              label="戻る"
              disabled={isCreating}
              onClick={handleBackClick}
              style={{
                fontSize: size,
                width: "fit-content",
                minWidth: "fit-content",
              }}
              displaySize={displaySize}
            />
          )}
      </div>
    );
  };
  const handleSubmit = async (values: any) => {
    if (dataApp?.app_parts) {
      const dataSubmit = handleDataSubmitFinish(
        values,
        dataApp?.app_parts,
        appType,
      );
      await createRecordAsync({
        payload: dataSubmit,
      });
      handleBack();
    }
  };
  return (
    <div>
      {isSuccessApp && (
        <>
          {renderButtonActions()}
          <Form form={form} onFinish={handleSubmit}>
            <LayoutApp
              dataApp={dataApp}
              isEditPage={false}
              isLoading={isLoadingApp || isCreating}
              isEditing={true}
              form={form}
              isCreate={true}
              disabledOnCreate={disabledOnCreate}
              allowSearchDate
              companyId={companyId}
              permission={{
                create: true,
                view: true,
                edit: true,
                delete: true,
                all: true,
              }}
              {...props}
            />
          </Form>
          <ModalConfirm
            isOpen={openConfirmBack}
            content={
              "これまでに入力した内容は保存されません。\nこのまま戻ってもよろしいですか。"
            }
            onCancel={() => setOpenConfirmBack(false)}
            onOk={() => {
              setOpenConfirmBack(false);
              handleBack();
            }}
          />
        </>
      )}
    </div>
  );
};

const CreatePage = (props: IProps) => (
  <UploadStatusProvider>
    <CreatePageInner {...props} />
  </UploadStatusProvider>
);

export default CreatePage;
